import { TImageTag } from '@typings'

const imageTags: TImageTag[] = ['sharing-emoji', 'upload-item-image-suggestion']

export default imageTags
